import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "vue" }
const _hoisted_2 = { class: "outputs" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("pre", null, [
  /*#__PURE__*/_createTextVNode("      "),
  /*#__PURE__*/_createElementVNode("code", { class: "language-javascript" }, "\n        import fpmoney from 'fp-money/dist/fp-money-vue.js'\n\n        export default {\n          components: { fpmoney },\n          data() {\n            return {\n              value: 86753.09,\n              int: '',\n              format: '',\n              display: '',\n              currency: '',\n              locale: 'en-us'\n            }\n          },\n          methods: {\n            change(values) {\n              console.log(values)\n            }\n          }\n        }\n      "),
  /*#__PURE__*/_createTextVNode("\n    ")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("pre", null, [
  /*#__PURE__*/_createTextVNode("      "),
  /*#__PURE__*/_createElementVNode("code", { class: "language-html" }, "\n        <fpmoney id=\"example\" \n          v-model=\"value\" \n          :value.sync=\"int\"           <-- Optional\n          :format.sync=\"format\"       <-- Optional\n          :display.sync=\"display\"     <-- Optional\n          :currency.sync=\"currency\"   <-- Optional\n          :locale=\"locale\"            <-- Optional\n          :disabled=\"false\"           <-- Optional\n          :displayOnly=\"false\"        <-- Optional\n          valueFormat=\"float | int\"   <-- Optional - default float\n          :minValue=\"minValue\"        <-- Optional\n          :maxValue=\"maxValue\"        <-- Optional\n          :step=\"step\"                <-- Optional\n          :onChange=\"change\"          <-- Optional \n          :showSelection=\"false\"      <-- Optional\n        />\n      "),
  /*#__PURE__*/_createTextVNode("\n    ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fpmoney = _resolveComponent("fpmoney")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_fpmoney, {
      id: "example",
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
      value: _ctx.int,
      format: _ctx.format,
      display: _ctx.display,
      currency: _ctx.currency,
      currencies: _ctx.currencies,
      locale: _ctx.locale,
      onChange: _ctx.change,
      showSelection: true,
      valueFormat: "int"
    }, null, 8, ["modelValue", "value", "format", "display", "currency", "currencies", "locale", "onChange"]),
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(" Value: " + _toDisplayString(_ctx.int), 1),
      _hoisted_3,
      _createTextVNode(" Format: " + _toDisplayString(_ctx.format), 1),
      _hoisted_4,
      _createTextVNode(" Display: " + _toDisplayString(_ctx.display), 1),
      _hoisted_5,
      _createTextVNode(" Currency: " + _toDisplayString(_ctx.currency), 1)
    ]),
    _hoisted_6,
    _hoisted_7
  ]))
}